/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Divider, InputAdornment, ListItemText } from "@mui/material";
import React, { useCallback, useEffect, useState } from "react";
import theme from "../../theme";
import Grid from "@mui/material/Grid2";
import {
  LockerExpiryText,
  LockerExpiryValue,
  StyledBox,
  StyledBoxDis,
  StyledBoxFrame,
  StyledBoxLocker,
  StyledBoxMain,
  StyledBoxTextInner,
  StyledGrid,
  StyledGridList,
  StyledIDBox,
  StyledIDText,
  StyledImageBox,
  StyledInnerBox,
  StyledItemListContainer,
  StyledItemsContainer,
  StyledList,
  StyledListItem,
  StyledSearchIcon,
  StyledTypographyRol,
  StyledTypographyText,
} from "./style";

import LockerLogo from "../../assets/images/locker-icon.png";
import CustomChip from "../../components/common/chip/chip";
import vector from "../../assets/images/vector-icon.png";
import clock from "../../assets/svg/clock.svg";
import ellipse from "../../assets/images/ellipse.png";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { StyledBoxStyle } from "../../components/common/input/style";
import { StyledNavbarSearch } from "../../components/common/navbar/style";
import CustomLocker from "../../components/list-item/ListItem";
import CreateShipmentSvg from "../../assets/Icons/Create";
import CustomButton from "../../components/common/button/CustomButton";
import BlockLock from "../../components/block-lock/BlockLock";
import { useDispatch, useSelector } from "react-redux";
import {
  GET_VIRTUAL_LOCKER,
  ADD_VIRTUAL_LOCKER,
} from "../../actions/AddressActions";
import SuccessVirtual from "../../components/modals/success-virtual-locker/SuccessVIrtual";
import CreateSuccessVirtual from "../../components/modals/create-success-virtual-locker/CreateSuccessVirtual";
import ProductDetails from "../../components/modals/product-details/ProductDetails";
import { formatName, formatToLongDate } from "../../utils/common";
import { VIRTUAL_LOCKER_GET_ITEM } from "../../actions/VirtualLockerAction";
import { CUSTOMER_ORDER_LIST } from "../../actions/OrderAction";
import {
  ADD_LOCKER_ITEMS_BLOCKED_MESSAGE,
  canAddVirtualLockerItems,
  getLockerItemBlockReason,
  hasActiveCustomerOrder,
  resolveLockerStatus,
} from "../../utils/orderCreateEligibility";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import InactiveLockerModal from "../../components/modals/inactive-locker/InactiveLockerModal";
import {
  CREATE_ORDER_PATH,
  clearInactiveLockerModalDismiss,
  dismissInactiveLockerModal,
  isInactiveLockerModalDismissed,
} from "../../utils/inactiveLockerPrompt";

const Locker = () => {
  const [searchItem, setSearchItem] = useState();

  const dispatch = useDispatch();
  const virtualLockerModel = useCallback(
    (values) => {
      dispatch({ type: ADD_VIRTUAL_LOCKER, payload: values });
    },
    [dispatch]
  );
  useEffect(() => {
    virtualLockerModel();
  }, [virtualLockerModel]);

  useEffect(() => {
    dispatch({ type: CUSTOMER_ORDER_LIST, payload: { page: 1, limit: 10 } });
  }, [dispatch]);

  const { orderSummary, hasFetchedCustomerOrderList, recordList } = useSelector(
    (state) => state?.order ?? {}
  );
  const lockerGetDetails = useSelector(
    (state) => state?.address?.virtualAddress
  );
  const canAddItems = canAddVirtualLockerItems(
    orderSummary,
    hasFetchedCustomerOrderList,
    recordList,
    lockerGetDetails
  );
  const addItemsBlockReason =
    getLockerItemBlockReason(
      lockerGetDetails,
      orderSummary,
      hasFetchedCustomerOrderList,
      recordList
    ) || ADD_LOCKER_ITEMS_BLOCKED_MESSAGE;
  const hasActiveOrder = hasActiveCustomerOrder(
    orderSummary,
    hasFetchedCustomerOrderList,
    recordList
  );
  const hasLocker =
    lockerGetDetails &&
    !Array.isArray(lockerGetDetails) &&
    Boolean(lockerGetDetails.locker_id);
  const lockerStatus = resolveLockerStatus(lockerGetDetails);
  const isLockerInactive = lockerStatus === "inactive";

  const virtualModel = useSelector((state) => state?.address?.virtualAddress);
  const navigate = useNavigate();

  const [openVirtualSuccess, setOpenVirtualSuccess] = useState(false);
  const [openVirtualSuccessGet, setOpenVirtualSuccessGet] = useState(false);
  const [openInactiveModal, setOpenInactiveModal] = useState(false);
  const lockerId = useSelector((state) => state?.address?.virtualAddress?.locker_id);
  const handleOpenVirtualSuccess = () => setOpenVirtualSuccess(true);
  const handleCloseVirtualSuccess = () => {
    setOpenVirtualSuccess(false);
    if(!lockerId){
      navigate("/dashboard/orders");
    }
  };
  const handleAcceptVirtualSuccess = () => {
    setOpenVirtualSuccess(false);
    dispatch({
      type: GET_VIRTUAL_LOCKER,
      payload: {
        onSuccess: () => {
          virtualLockerModel({
            onSuccess: (lockerData) => {
              if (!lockerData?.locker_id) {
                navigate("/dashboard/orders");
              }
            },
          });
        },
      },
    });
  };
  const isVirtualModel = !!virtualModel;
  useEffect(() => {
    if (!hasFetchedCustomerOrderList || hasActiveOrder || hasLocker) {
      if (hasActiveOrder || hasLocker) {
        setOpenVirtualSuccess(false);
      }
      return;
    }
    if (!virtualModel) {
      handleOpenVirtualSuccess();
    }
  }, [isVirtualModel, hasLocker, hasActiveOrder, hasFetchedCustomerOrderList]);

  useEffect(() => {
    if (!lockerId || isLockerInactive) return;
    clearInactiveLockerModalDismiss(lockerId);
  }, [lockerId, isLockerInactive]);

  useEffect(() => {
    if (
      !hasLocker ||
      !hasFetchedCustomerOrderList ||
      openVirtualSuccess ||
      openVirtualSuccessGet ||
      !isLockerInactive
    ) {
      setOpenInactiveModal(false);
      return;
    }
    if (isInactiveLockerModalDismissed(lockerId)) {
      setOpenInactiveModal(false);
      return;
    }
    setOpenInactiveModal(true);
  }, [
    hasLocker,
    hasFetchedCustomerOrderList,
    openVirtualSuccess,
    openVirtualSuccessGet,
    isLockerInactive,
    lockerId,
  ]);

  const handleCloseInactiveModal = () => {
    dismissInactiveLockerModal(lockerId);
    setOpenInactiveModal(false);
  };

  const handleOpenVirtualSuccessGet = () => setOpenVirtualSuccessGet(true);
  const handleCloseVirtualSuccessGet = () => {
    setOpenVirtualSuccessGet(false)
    navigate("/dashboard/locker-v2")
  };

  // const handleAccept = React.useCallback(() => {
  //   dispatch({
  //     type: GET_VIRTUAL_LOCKER,
  //     payload: {
  //       onSuccess: () => {
  //         handleOpenVirtualSuccessGet();
  //         virtualLockerModel();
  //       },
  //     },
  //   });
  // }, [dispatch]);

  const [openProductDetails, setOpenProductDetails] = useState(false);
  const handleOpenProductDetails = () => setOpenProductDetails(true);
  const handleCloseProductDetails = () => setOpenProductDetails(false);

  const getItemLocker = useCallback(
    (values) => {
      dispatch({
        type: VIRTUAL_LOCKER_GET_ITEM,
        payload: values,
      });
    },
    [dispatch]
  );

  useEffect(() => {
    getItemLocker({product_name: searchItem});
  }, [getItemLocker, searchItem]);
  const getItemData = useSelector(
    (state) => state?.virtual?.lockerGetList?.data
  );

  const today = new Date();
  const expiryDate = new Date(lockerGetDetails?.locker_expiry_date);

  let diffDays;
  if (!isNaN(expiryDate)) {
    const diffTime = expiryDate - today;
    diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  } else {
    diffDays = "Invalid date";
  }

  return (
    <>
      <StyledBoxMain>
        <StyledBoxTextInner>
          <StyledTypographyText>VIRTUAL LOCKER</StyledTypographyText>
          <Box>
            <CustomButton
              fontSize={theme.typography.small.fontSize}
              startIcon={<CreateShipmentSvg width={20} height={20} />}
              btntype="warning"
              btnLabel="Add New Items"
              disabled={!canAddItems || isLockerInactive}
              onClick={() => {
                if (isLockerInactive) {
                  if (!isInactiveLockerModalDismissed(lockerId)) {
                    setOpenInactiveModal(true);
                  } else {
                    toast.error(addItemsBlockReason);
                  }
                  return;
                }
                if (!canAddItems) {
                  toast.error(addItemsBlockReason);
                  return;
                }
                navigate("/dashboard/locker/item");
              }}
            />
          </Box>
        </StyledBoxTextInner>
        <StyledGrid container spacing={2}>
          <Grid size={{ xl: 7, lg: 7, md: 12, sm: 7, xs: 12 }}>
            <StyledBoxDis>
              <img
                src={LockerLogo}
                alt="LockerLogo"
                width={80}
                height={80}
                loading="lazy"
              />

              <Box>
                <StyledTypographyRol>Rules</StyledTypographyRol>
                <StyledList>
                  <StyledListItem>
                    <ListItemText primary="Lorem ipsum dolor sit amet, consectetur adipiscing elit sit ipsum" />
                  </StyledListItem>
                  <StyledListItem>
                    <ListItemText primary="Lorem ipsum dolor sit amet, consectetur adipiscing elit sit ipsum" />
                  </StyledListItem>
                  <StyledListItem>
                    <ListItemText primary="Lorem ipsum dolor sit amet, consectetur adipiscing elit" />
                  </StyledListItem>
                </StyledList>
              </Box>
            </StyledBoxDis>
          </Grid>
          <Grid size={{ xl: 5, lg: 5, md: 12, sm: 5, xs: 12 }}>
            <StyledBoxFrame>
              <CustomChip
                padding="9px 20px"
                title="Upgrade"
                color={theme.palette.custom.white}
                background={theme.palette.custom.danger}
              />
              <img loading="lazy" src={vector} alt="vector" />
              <StyledBox>
                {lockerGetDetails?.locker_expiry_date && (
                  <StyledInnerBox>
                    <StyledImageBox>
                      <img loading="lazy" src={clock} alt="icon" />
                    </StyledImageBox>
                    <StyledBoxLocker>
                      <LockerExpiryText>Locker Expiry</LockerExpiryText>
                      <LockerExpiryValue>{(diffDays<=0)? `Expired` : `${diffDays} Days`}</LockerExpiryValue>
                    </StyledBoxLocker>
                  </StyledInnerBox>
                )}
                {lockerGetDetails?.locker_id && (
                  <StyledIDBox>
                    <img
                      loading="lazy"
                      width={8}
                      height={8}
                      src={ellipse}
                      alt="ellipse"
                    />

                    <StyledIDText>
                      ID:{lockerGetDetails?.locker_id}
                    </StyledIDText>
                    <KeyboardArrowDownIcon />
                  </StyledIDBox>
                )}
              </StyledBox>
            </StyledBoxFrame>
          </Grid>
        </StyledGrid>

        <StyledItemListContainer>
          <StyledGridList container spacing={2}>
            <Grid size={{ lg: 6, md: 6, xs: 6 }}>
              <StyledTypographyText>List of Items</StyledTypographyText>
            </Grid>
            <Grid size={{ lg: 6, md: 6, xs: 6 }}>
              <StyledBoxStyle>
                <StyledNavbarSearch
                  placeholder="Order / Shipment no"
                  variant="outlined"
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <StyledSearchIcon />
                      </InputAdornment>
                    ),
                  }}
                  onChange={(e) => setSearchItem(e.target.value)}
                />
              </StyledBoxStyle>
            </Grid>
          </StyledGridList>

          <Divider />
          <StyledItemsContainer>
            <Grid container spacing={1} alignItems="stretch">
              {getItemData?.map((item, ind) => {
                return (
                  <Grid 
                    size={{ lg: 4, md: 6, sm: 12, xs: 12 }} 
                    key={item?.id} 
                    sx={{ display: 'flex' }}
                  >
                    <Box sx={{ width: '100%', display: 'flex' }}>
                      <CustomLocker
                        ind={ind}
                        getItemLocker={getItemLocker}
                        status={item?.status}
                        itemId={item?.id}
                        product={formatName(item?.product_name)}
                        chip1Title={item?.shelf_no}
                        createUser={item?.create_by_user}
                        quantity={item?.quantity}
                        chip2Title={formatName(item?.order_type)}
                        sendNumOrValue={formatName(item?.order_type)}
                        senderType={formatName(item?.order_type)}
                        createdAt={formatToLongDate(item?.createdAt)}
                        expDelivery={formatToLongDate(item?.estimated_delivery)}
                        images={item?.product_image || []}
                        note={item?.note_to_customer}
                      />
                    </Box>
                  </Grid>
                );
              })}

              <Grid
                size={{ lg: 4, md: 6, sm: 12, xs: 12 }}
                sx={{ display: 'flex' }}
              >
                <Box sx={{ width: '100%', display: 'flex' }}>
                  <BlockLock
                    handleOpen={() => {
                      if (isLockerInactive) {
                        if (!isInactiveLockerModalDismissed(lockerId)) {
                          setOpenInactiveModal(true);
                        } else {
                          toast.error(addItemsBlockReason);
                        }
                        return;
                      }
                      if (!canAddItems) {
                        toast.error(addItemsBlockReason);
                        return;
                      }
                      navigate("/dashboard/locker/item");
                    }}
                    disabled={!canAddItems || isLockerInactive}
                    disabledReason={addItemsBlockReason}
                  />
                </Box>
              </Grid>
            </Grid>
          </StyledItemsContainer>
        </StyledItemListContainer>
      </StyledBoxMain>

      {openVirtualSuccess && (
        <SuccessVirtual
          open={openVirtualSuccess}
          handleOpen={handleOpenVirtualSuccess}
          handleClose={handleCloseVirtualSuccess}
          handleAccept={handleAcceptVirtualSuccess}
        />
      )}

      {openVirtualSuccessGet && (
        <CreateSuccessVirtual
          open={openVirtualSuccessGet}
          handleOpen={handleOpenVirtualSuccessGet}
          handleClose={handleCloseVirtualSuccessGet}
        />
      )}

      {openInactiveModal && (
        <InactiveLockerModal
          open={openInactiveModal}
          onClose={handleCloseInactiveModal}
          hasExistingOrder={hasActiveOrder}
          onCreateOrder={() => {
            handleCloseInactiveModal();
            navigate(CREATE_ORDER_PATH);
          }}
        />
      )}

      {openProductDetails && (
        <ProductDetails
          open={openProductDetails}
          handleOpen={handleOpenProductDetails}
          handleClose={handleCloseProductDetails}
        />
      )}
    </>
  );
};

export default Locker;
